"use strict";
// Общие скрипты портала. Компилируется gulp-задачей scriptsTs (tsconfig.json)
// и склеивается в bundle.js вместе с popper/bootstrap.
/**
 * Поиск в шапке на мобильном (<=991px): пилюля свёрнута до кружка-лупы
 * (стиль как у корзины), клик по нему разворачивает форму поверх всей
 * шапки. На десктопе форма живёт в строке меню, и этот код не вмешивается.
 *
 * Поведение: первый клик по лупе — только разворачивает и ставит фокус в
 * поле; развёрнутая форма сабмитится обычным образом (Enter или лупа).
 * Закрытие: крестик, Esc, клик вне формы, переход на десктопную ширину.
 */
function initHeaderSearch() {
    const form = document.querySelector('.site-header .nav-search');
    if (!form) {
        return;
    }
    const input = form.querySelector('input[name="q"]');
    const submit = form.querySelector('button[type="submit"]');
    if (!input || !submit) {
        return;
    }
    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'nav-search-close';
    closeBtn.setAttribute('aria-label', 'Закрыть поиск');
    closeBtn.innerHTML = '<i class="bi bi-x-lg" aria-hidden="true"></i>';
    form.appendChild(closeBtn);
    const mobileQuery = window.matchMedia('(max-width: 991.98px)');
    const close = () => {
        form.classList.remove('is-open');
    };
    submit.addEventListener('click', (event) => {
        // Свёрнутая лупа — первый клик только разворачивает поиск;
        // развёрнутая форма сабмитится нативно.
        if (!mobileQuery.matches || form.classList.contains('is-open')) {
            return;
        }
        event.preventDefault();
        form.classList.add('is-open');
        input.focus();
    });
    closeBtn.addEventListener('click', close);
    // Явный сабмит по Enter в развёрнутом поле: страховка на случай, когда
    // нативная имплицитная отправка не срабатывает (синтетические события,
    // экзотические клавиатуры). На десктопе и в свёрнутом виде не вмешиваемся.
    input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && mobileQuery.matches && form.classList.contains('is-open')) {
            event.preventDefault();
            form.submit();
        }
    });
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            close();
        }
    });
    document.addEventListener('click', (event) => {
        if (form.classList.contains('is-open')
            && event.target instanceof Node
            && !form.contains(event.target)) {
            close();
        }
    });
    mobileQuery.addEventListener('change', close);
}
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderSearch);
}
else {
    initHeaderSearch();
}
